import $ from 'jquery';
const INPUT_SELECTOR = '.js__select-all-input';
export default class SelectAllInput {
    static init() {
        if (!$(INPUT_SELECTOR).length) {
            return;
        }
        this.initSelectAllInput();
    }
    static initSelectAllInput() {
        $(INPUT_SELECTOR).each((i, element) => {
            const $element = $(element);
            const excludeElements = $element.data('exclude-elements') || INPUT_SELECTOR;
            const $otherCheckboxes = $element
                .closest($element.data('select-all-wrapper') || 'form')
                .find(`[type="checkbox"]:not(${excludeElements})${$element.data('input-selector')}`);
            const $groupedCheckboxes = $($element.data('select-all-grouped-wrapper')).find(`[type="checkbox"]:not(${excludeElements})${$element.data('input-selector')}`);
            $element.on('change', e => {
                if ($element.is(':checked')) {
                    $otherCheckboxes.prop('checked', true).trigger('change').trigger('keyup');
                    $groupedCheckboxes.prop('checked', true).trigger('change').trigger('keyup');
                }
                else {
                    $otherCheckboxes.prop('checked', false).trigger('change').trigger('keyup');
                    $groupedCheckboxes.prop('checked', false).trigger('change').trigger('keyup');
                }
            });
            $otherCheckboxes.on('change', e => {
                this.uncheckWrapperCheckbox($(e.currentTarget), $element);
            });
            $groupedCheckboxes.on('change', e => {
                this.uncheckWrapperCheckbox($(e.currentTarget), $element);
            });
        });
    }
    static uncheckWrapperCheckbox = ($checkbox, $wrapperCheckbox) => {
        if (!$checkbox.is(':checked')) {
            $wrapperCheckbox.prop('checked', false);
        }
    };
}
